// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buyer-tiers-container {
  font-family: "Proxima Nova", sans-serif;
  padding: 32px 0;
}
.buyer-tiers-container .buyer-tiers-container-header {
  background-color: #FDF1C7;
  border-radius: 24px;
  padding: 40px;
}
.buyer-tiers-container .buyer-tiers-container-header .free-text {
  font-size: 24px;
  margin: 0;
  color: #5f5f5f;
  font-weight: 700;
}
.buyer-tiers-container .buyer-tiers-container-header .highlight {
  background-color: #ffc107;
  padding: 10px;
  border-radius: 14px;
  color: white;
  font-size: 32px;
  margin: 0 16px;
  line-height: normal;
}
.buyer-tiers-container .buyer-tiers-container-header .see-tiers-button {
  background-color: #ffc107;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
}
.buyer-tiers-container .buyer-tiers-container-header .steps-container {
  display: flex;
  justify-content: space-between;
  column-gap: 90px;
}
.buyer-tiers-container .buyer-tiers-container-header .steps-container .step {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.buyer-tiers-container .buyer-tiers-container-header .steps-container .step h2 {
  font-size: 32px;
  color: #ffc107;
  margin: 0;
  font-weight: 700;
}
.buyer-tiers-container .buyer-tiers-container-header .steps-container .step h3 {
  font-size: 16px;
  margin: 0;
  color: #2A2A2A;
  font-weight: 700;
}
.buyer-tiers-container .buyer-tiers-container-header .steps-container .step p {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #2A2A2A;
  margin: 0;
}
.buyer-tiers-container .buyer-tiers-container-catalogue {
  display: flex;
  column-gap: 32px;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card.queen {
  color: white !important;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card.queen .sub-title, .buyer-tiers-container .buyer-tiers-container-catalogue .tier-card.queen h2, .buyer-tiers-container .buyer-tiers-container-catalogue .tier-card.queen .description {
  color: white !important;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card.queen h2 {
  color: #ffc107 !important;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card.queen .perk h3 {
  color: #E7B713 !important;
  background-color: #FFECAD;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card.queen .perk ul li {
  color: white !important;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card h2 {
  font-size: 24px;
  font-weight: 700;
  color: #2A2A2A;
  margin: 0;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card .sub-title {
  font-size: 12px;
  font-weight: 400;
  color: #949494;
  margin: 0;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card .description {
  font-size: 14px;
  font-weight: 700;
  color: #2A2A2A;
  margin: 0;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card .perk h3 {
  font-size: 14px;
  font-weight: 700;
  color: #2A2A2A;
  width: 100%;
  background-color: #F3F3F3;
  padding: 8px;
  text-align: center;
  border-radius: 8px;
  margin: 0;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card .perk ul {
  padding: 0;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card .perk ul li {
  font-size: 14px;
  font-weight: 400;
  color: #2A2A2A;
  margin: 0;
  line-height: 20px;
}
.buyer-tiers-container .buyer-tiers-container-catalogue .tier-card .perk ul li > svg {
  white-space: nowrap;
  margin-top: 2px;
  margin-right: 8px;
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .buyer-tiers-container .buyer-tiers-container-catalogue {
    flex-wrap: wrap;
    gap: 32px;
    justify-content: center;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .buyer-tiers-container .buyer-tiers-container-header .free-text {
    line-height: 52px;
  }
  .buyer-tiers-container .buyer-tiers-container-header .steps-container {
    flex-direction: column;
    row-gap: 24px;
  }
  .buyer-tiers-container .buyer-tiers-container-catalogue {
    flex-direction: column;
    row-gap: 24px;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/BeeTier/modules/PublicCatalog/publicCatalog.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,uCAAA;EACA,eAAA;AADJ;AAEI;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;AAAR;AAEQ;EACI,eAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAAZ;AAGQ;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AADZ;AAIQ;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAFZ;AAKQ;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AAHZ;AAKY;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAHhB;AAKgB;EACI,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAHpB;AAMgB;EACI,eAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAJpB;AAOgB;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AALpB;AAWI;EACI,aAAA;EACA,gBAAA;AATR;AAUQ;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;AARZ;AASY;EACI,uBAAA;AAPhB;AAQgB;EACI,uBAAA;AANpB;AAQgB;EACI,yBAAA;AANpB;AASoB;EACI,yBAAA;EACA,yBAAA;AAPxB;AAUwB;EACI,uBAAA;AAR5B;AAaY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAXhB;AAaY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAXhB;AAaY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAXhB;AAcgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAZpB;AAcgB;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAZpB;AAaoB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AAXxB;AAYwB;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;AAV5B;;AC5HY;EDiJJ;IACI,eAAA;IACA,SAAA;IACA,uBAAA;EAjBV;AACF;AC3IY;EDoKA;IACI,iBAAA;EAtBd;EAwBU;IACI,sBAAA;IACA,aAAA;EAtBd;EAyBM;IACI,sBAAA;IACA,aAAA;IACA,mBAAA;EAvBV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.buyer-tiers-container {\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    padding: 32px 0;\r\n    .buyer-tiers-container-header {\r\n        background-color: #FDF1C7;\r\n        border-radius: 24px;\r\n        padding: 40px;\r\n\r\n        .free-text {\r\n            font-size: 24px;\r\n            margin: 0;\r\n            color: #5f5f5f;\r\n            font-weight: 700;\r\n        }\r\n\r\n        .highlight {\r\n            background-color: #ffc107;\r\n            padding: 10px;\r\n            border-radius: 14px;\r\n            color: white;\r\n            font-size: 32px;\r\n            margin: 0 16px;\r\n            line-height: normal;\r\n        }\r\n\r\n        .see-tiers-button {\r\n            background-color: #ffc107;\r\n            border: none;\r\n            padding: 10px 20px;\r\n            border-radius: 5px;\r\n            font-weight: bold;\r\n            cursor: pointer;\r\n        }\r\n\r\n        .steps-container {\r\n            display: flex;\r\n            justify-content: space-between;\r\n            column-gap: 90px;\r\n\r\n            .step {\r\n                flex: 1;\r\n                display: flex;\r\n                flex-direction: column;\r\n                row-gap: 8px;\r\n\r\n                h2 {\r\n                    font-size: 32px;\r\n                    color: #ffc107;\r\n                    margin: 0;\r\n                    font-weight: 700;\r\n                }\r\n\r\n                h3 {\r\n                    font-size: 16px;\r\n                    margin: 0;\r\n                    color: #2A2A2A;\r\n                    font-weight: 700;\r\n                }\r\n\r\n                p {\r\n                    font-size: 16px;\r\n                    line-height: 24px;\r\n                    font-weight: 400;\r\n                    color: #2A2A2A;\r\n                    margin: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n    .buyer-tiers-container-catalogue {\r\n        display: flex;\r\n        column-gap: 32px;\r\n        .tier-card {\r\n            display: flex;\r\n            height: 100%;\r\n            flex-direction: column;\r\n            justify-content: space-between;\r\n            &.queen {\r\n                color: white !important;\r\n                .sub-title, h2, .description {\r\n                    color: white !important;\r\n                }\r\n                h2 {\r\n                    color: #ffc107 !important;\r\n                }\r\n                .perk {\r\n                    h3 {\r\n                        color: #E7B713 !important;\r\n                        background-color: #FFECAD;\r\n                    }\r\n                    ul {\r\n                        li {\r\n                            color: white !important;\r\n                        }\r\n                    }\r\n                }\r\n            } \r\n            h2 {\r\n                font-size: 24px;\r\n                font-weight: 700;\r\n                color: #2A2A2A;\r\n                margin: 0;\r\n            }\r\n            .sub-title {\r\n                font-size: 12px;\r\n                font-weight: 400;\r\n                color: #949494;\r\n                margin: 0;\r\n            }\r\n            .description {\r\n                font-size: 14px;\r\n                font-weight: 700;\r\n                color: #2A2A2A;\r\n                margin: 0;\r\n            }\r\n            .perk {\r\n                h3 {\r\n                    font-size: 14px;\r\n                    font-weight: 700;\r\n                    color: #2A2A2A;\r\n                    width: 100%;\r\n                    background-color: #F3F3F3;\r\n                    padding: 8px;\r\n                    text-align: center;\r\n                    border-radius: 8px;\r\n                    margin: 0;\r\n                }\r\n                ul {\r\n                    padding: 0;\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    row-gap: 8px;\r\n                    li {\r\n                        font-size: 14px;\r\n                        font-weight: 400;\r\n                        color: #2A2A2A;\r\n                        margin: 0;\r\n                        line-height: 20px;\r\n                        > svg {\r\n                            white-space: nowrap;\r\n                            margin-top: 2px;\r\n                            margin-right: 8px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(tablet) {\r\n    .buyer-tiers-container {\r\n        .buyer-tiers-container-catalogue {\r\n            flex-wrap: wrap;\r\n            gap: 32px;\r\n            justify-content: center;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@include media(mobile) {\r\n    .buyer-tiers-container {\r\n        .buyer-tiers-container-header {\r\n            .free-text {\r\n                line-height: 52px;\r\n            }\r\n            .steps-container {\r\n                flex-direction: column;\r\n                row-gap: 24px;\r\n            }\r\n        }\r\n        .buyer-tiers-container-catalogue {\r\n            flex-direction: column;\r\n            row-gap: 24px;\r\n            align-items: center;\r\n        }\r\n    }\r\n}\r\n","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
